"use client";

import type { DisplayType } from "../../../../lib/types/enums/displayTypeEnum";
import { sectionSchema } from "../../../../lib/types/schema/home/sectionSchema";
import type { UseRequestProps } from "../../../../request/hooks/useRequest";
import { useRequestQuery } from "../../../../request/hooks/useRequestQuery";
import { keyMeRecents } from "./keyMeRecents";

export type UseRequestMeRecentsProps = UseRequestProps & {
  displayType: DisplayType;
};

export const useRequestMeRecents = ({
  displayType,
  ...props
}: UseRequestMeRecentsProps) => ({
  ...props,
  query: useRequestQuery({
    queryFnRequestProps: {
      schema: sectionSchema,
      urlBackendPath: `/me/recents${displayType === "sessions" ? "?format=prayer" : ""}`,
    },
    queryKey: keyMeRecents({ displayType }),
  }),
});
